module.exports = __webpack_public_path__ + "static/media/accessory__dupont.cecbe71b.jpg";